import { inject } from '@angular/core';
import { EnergyInterfacesStore } from '../stores/energy-interfaces.store';

export const energyInterfacesLoadedGuard = () => {
  const energyInterfacesStore = inject(EnergyInterfacesStore);
  if (
    !energyInterfacesStore.allLoaded() &&
    !energyInterfacesStore.isLoading() &&
    !energyInterfacesStore.error()
  ) {
    energyInterfacesStore.load();
  }
  return true;
};
